module.exports = __webpack_public_path__ + "img/position-white.4d6dd168.png";